import React from 'react';
import "../Figure.css"


function Figure11() {
  return (
    <div>
        <table class="equal-width-table">
          <thead>
            <tr>
             <th rowspan="2"></th>
              <th colSpan="5">GFP concentration</th>
            </tr>
            <tr>
              <th ></th>
              <th> 20 µg/mL </th>
              <th> 10 µg/mL </th>
              <th> 5 µg/mL </th>
              <th> 2.5 µg/mL </th>
            </tr>
          </thead>
          <tbody>
          <tr>
              <th rowspan="3">PK conditions</th>
              <th> RT </th>
              <td className="blue-cell"> 4.6% </td>
              <td className="concentration-header orange-cell"> 3% </td>
              <td className="blue-cell"> 0% </td>
              <td className="blue-cell">  8.8% </td>
            </tr> 
            <tr>
              <th> 30°C </th>
              <td className="blue-cell"> 15.5% </td>
              <td className="blue-cell"> 29.3% </td>
              <td className="blue-cell"> 20% </td>
              <td className="blue-cell"> 20% </td>
            </tr>
            <tr>
              <th> 37°C </th>
              <td className="blue-cell"> 10.3% </td>
              <td className="blue-cell"> 15.6% </td>
              <td className="blue-cell"> 22.2% </td>
              <td className="blue-cell"> 20% </td>
            </tr>
          </tbody>
        </table>
    </div>
  );
}

export default Figure11;